// components/SavePopup.jsx
import { useState } from "react";
// import axios from 'axios';
import styles from "./SavePopup.module.css";


export default function SavePopup({ onClose, onSave, existingData = {}, hasUnsavedChanges}) {
  const [email, setEmail] = useState(existingData.email || "");
  const [companyName, setCompanyName] = useState(existingData.companyName || "");
  const [projectName, setProjectName] = useState(existingData.projectName || "");

  const formChanged = () =>
    email !== (existingData.email || "") ||
    companyName !== (existingData.companyName || "") ||
    projectName !== (existingData.projectName || "");

/*   const saveSurvey = (e) => {
    e.preventDefault();
    if (!email || !company || !projectName) return alert("יש למלא את כל השדות");
    onSave({ email, company, projectName });
  }; */

/*   const saveSurvey = async (event) => {
    event.preventDefault();
    console.log("1");
    let result = await axios.put(process.env.REACT_APP_API_URL + '/save_survey' , { "field": 1 })
    console.log("2");
    if (result.status === 200) {
        console.log("success");
    } else {
        console.log("failed");
    }
  } */

  const saveSurvey = async (event) => {
    event.preventDefault();

    if (!email || !companyName || !projectName) {
      alert("יש למלא את כל השדות");
      return;
    }

    const body = {
      email,
      companyName,
      projectName
    };

    onSave({ email, companyName, projectName });

/*     try {
      const response = await axios.post(process.env.REACT_APP_API_URL + "/save_survey", body);
      console.log(`${process.env.REACT_APP_API_URL}/save_survey`);
      if (response.data.created) {
        console.log("New user created:", response.data.user);
      } else {
        console.log("Existing user found:", response.data.user);
      }
      onClose();
    } catch (err) {
      console.error("Failed to create/find user:", err);
    } */
  };

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent}>
        <h2>שמירת התקדמותך בשאלון</h2>
        <p>הזינו את פרטיכם לשמירה ולשוב בהמשך למילוי השאלון</p>
        <form onSubmit={saveSurvey}>
          <label>
            מייל:
            <input type="email" value={email} onChange={e => setEmail(e.target.value)} required autoFocus/>
          </label>
          <label>
            שם החברה:
            <input type="text" value={companyName} onChange={e => setCompanyName(e.target.value)} required/>
          </label>
          <label>
            שם הפרויקט (לצורך זיהוי בהמשך):
            <input type="text" value={projectName} onChange={e => setProjectName(e.target.value)} required/>
          </label>
          <div className={styles.buttonRow}>
            <button type="submit" disabled={!hasUnsavedChanges && !formChanged()}>שמור</button>
            <button type="button" onClick={onClose} className={styles.cancelBtn}>ביטול</button>
          </div>
        </form>
      </div>
    </div>
  );
}